import React, { useEffect, useState } from "react";
import axios from "axios";

const OpenVouchersBanner = ({ compact = false }) => {
  const [vouchers, setVouchers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchVouchers = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${process.env.REACT_APP_URI}/v1/open-vouchers`);
        const todayTs = Date.now();
        const active = (res.data || []).filter((v) => {
          const isInactive = v.active === false || v.isUsed === true;
          if (isInactive) return false;

          if (v.expiryDate) {
            const expiryTs = new Date(v.expiryDate).getTime();
            if (!Number.isNaN(expiryTs) && expiryTs < todayTs) return false; // ocultar vencidos
          }

          return true;
        });
        setVouchers(active);
      } catch (err) {
        console.error("Error cargando open vouchers", err);
      } finally {
        setLoading(false);
      }
    };
    fetchVouchers();
  }, []);

  if (loading) return null;
  if (!vouchers.length) return null;

  const containerStyle = compact
    ? { width: "100%", marginBottom: "1.5rem" }
    : { width: "100%", margin: "0.5rem auto" };
  const cardMinHeight = compact ? "220px" : "280px";
  const cardMaxWidth = compact ? "1180px" : "1180px";

  const resolveImage = (voucher) => {
    if (voucher.imageUrl?.startsWith("http")) return voucher.imageUrl;
    if (voucher.imageUrl) {
      return `https://muerdete-resourcesv2.s3.eu-west-3.amazonaws.com/open-vouchers/${voucher.id}/heroImage/${voucher.imageUrl}`;
    }
    return null;
  };

  return (
    <div style={containerStyle}>
      {!compact && (
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2 className="mb-0">Bonos disponibles</h2>
          <span className="text-muted">Edición especial</span>
        </div>
      )}
      <div className="d-flex flex-column align-items-center gap-3">
        {vouchers.map((voucher) => (
          <div key={voucher.id} className="w-100 d-flex justify-content-center">
            <div
              className="card border-0 text-white position-relative"
              style={{
                width: "100%",
                maxWidth: cardMaxWidth,
                minHeight: cardMinHeight,
                borderRadius: "18px",
                overflow: "hidden",
                boxShadow: "0 20px 40px rgba(0,0,0,0.16)",
                background: "linear-gradient(135deg, #d72638 0%, #7a1c29 100%)",
              }}
            >
              <div
                className="position-absolute"
                style={{
                  right: "-60px",
                  top: "-60px",
                  width: "160px",
                  height: "160px",
                  background: "radial-gradient(circle at center, rgba(255,255,255,0.35), rgba(0,0,0,0))",
                  transform: "rotate(20deg)",
                  opacity: 0.8,
                }}
              />
              <div
                className="position-absolute"
                style={{
                  left: "-80px",
                  bottom: "-80px",
                  width: "200px",
                  height: "200px",
                  background: "radial-gradient(circle at center, rgba(255,255,255,0.28), rgba(0,0,0,0))",
                  transform: "rotate(-15deg)",
                  opacity: 0.7,
                }}
              />
              <div className="p-4 p-md-5 d-flex flex-column flex-md-row align-items-center justify-content-between gap-4 text-center text-md-start">
                <div style={{ minWidth: "240px", width: "100%" }}>
                  <p className="mb-1 text-uppercase" style={{ letterSpacing: "0.08em", fontSize: "1rem", opacity: 0.95, fontWeight: 800 }}>
                    Bono especial
                  </p>
                  <h3 className="mb-2 text-white" style={{ fontSize: "2.1rem", fontWeight: 900 }}>
                    {voucher.name}
                  </h3>
                  <p className="mb-2" style={{ maxWidth: "520px", opacity: 0.95, fontSize: "1.05rem", fontWeight: 700 }}>
                    {voucher.description || "Bono regalo para canjear por cualquier experiencia."}
                  </p>
                </div>

                <div className="d-flex justify-content-center w-100 w-md-auto">
                  <div
                    style={{
                      width: compact ? "130px" : "150px",
                      height: compact ? "130px" : "150px",
                      borderRadius: "50%",
                      overflow: "hidden",
                      border: "3px solid rgba(255,255,255,0.4)",
                      background: "rgba(255,255,255,0.1)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 8px 18px rgba(0,0,0,0.12)",
                    }}
                  >
                    {resolveImage(voucher) ? (
                      <img
                        src={resolveImage(voucher)}
                        alt={voucher.name}
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                      />
                    ) : (
                      <span className="text-white fw-bold" style={{ fontSize: "1rem", padding: "6px", textAlign: "center" }}>
                        Muérdete
                      </span>
                    )}
                  </div>
                </div>

                <div className="d-flex flex-column align-items-center align-items-md-end gap-2 w-100 w-md-auto">
                  <a
                    className="btn btn-light text-dark fw-bold px-4 py-2"
                    href={`/comprar-bono?openVoucherId=${voucher.id}`}
                    style={{ borderRadius: "10px", boxShadow: "0 8px 18px rgba(0,0,0,0.18)" }}
                  >
                    Comprar bono
                  </a>
                  <span
                    className="text-white fw-bold px-2"
                    style={{ fontSize: "1.5rem", lineHeight: 1.2, minWidth: "140px", textAlign: "center" }}
                  >
                    {voucher.amount} €
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OpenVouchersBanner;

